import { SvgIcon } from '@mui/material'

import { IconProps } from './types'

const SupportColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 16 16" style={{ color, fontSize, ...style }} {...rest}>
      <path
        d="M15 5.375C15 7.79219 13.0422 9.75 10.625 9.75C10.1027 9.75 9.59961 9.65977 9.13477 9.49023L4.16914 14.4559C3.82188 14.8031 3.34883 15 2.85664 15C1.83125 15 1 14.1687 1 13.1434C1 12.6512 1.19688 12.1781 1.54414 11.8309L6.50977 6.86523C6.34297 6.40039 6.25 5.89727 6.25 5.375C6.25 2.95781 8.20781 1 10.625 1C11.0434 1 11.448 1.06016 11.8336 1.16953C12.1262 1.2543 12.1945 1.61797 11.9785 1.83398L9.87852 3.93398C9.79648 4.01602 9.75 4.12812 9.75 4.24297V5.8125C9.75 6.05312 9.94687 6.25 10.1875 6.25H11.757C11.8719 6.25 11.984 6.20352 12.066 6.12148L14.166 4.02148C14.382 3.80547 14.7457 3.87109 14.8305 4.16641C14.9398 4.55195 15 4.95664 15 5.375Z"
        stroke="#4078B9"
        fill="none"
        strokeWidth="1.3"
      />
    </SvgIcon>
  )
}

export default SupportColoredIcon
